import { render, staticRenderFns } from "./CampaignStatusView.vue?vue&type=template&id=684fade4&scoped=true&"
import script from "./CampaignStatusView.vue?vue&type=script&lang=ts&"
export * from "./CampaignStatusView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684fade4",
  null
  
)

export default component.exports